<div class="p-grid">
    <div class="p-col-12">

        <p-toast></p-toast>

        <div class="card">
            <p-toolbar styleClass="p-mb-4">
                <ng-template pTemplate="left">
                    <button pButton pRipple label="{{ 'label.novo' | translate }}" icon="pi pi-plus" class="p-button-success p-mr-2 p-mb-2" (click)="openNew()" *ngIf="perfil != null && perfil.nmePerfil === 'ADMTIVIT'"></button>
                </ng-template>

                <ng-template pTemplate="right">
                    <button pButton pRipple label="{{ 'label.exportar' | translate }}" icon="pi pi-upload" class="p-button-help p-mb-2" (click)="downloadFile()"></button>
                </ng-template>
            </p-toolbar>

            <p-table #dt [value]="carteiras" dataKey="id"
                     styleClass="p-datatable-customers" [rowHover]="true" [rows]="10" [paginator]="true"
                     [filterDelay]="0" [globalFilterFields]="['banco.codBanco', 'banco.nmeBanco','nroQtdRegistros','sglCarteiraBanco', 'desCarteiraBanco']">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                        <h5>{{ 'carteira.titulo' | translate }}</h5>
                        <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Global Search"/>
                </span>
                    </div>
               </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="banco.codBanco">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'banco.codigo' | translate }}
                                <p-sortIcon field="banco.codBanco"></p-sortIcon>
                                <p-columnFilter type="numeric" field="banco.codBanco" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="banco.nmeBanco">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'banco.nome' | translate }}
                                <p-sortIcon field="banco.nmeBanco"></p-sortIcon>
                                <p-columnFilter type="text" field="banco.nmeBanco" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                         <th pSortableColumn="codCarteira">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'carteira.codigo' | translate }}
                                <p-sortIcon field="codCarteira"></p-sortIcon>
                                <p-columnFilter type="text" field="codCarteira" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="sglCarteiraBanco">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'carteira.sigla' | translate }}
                                <p-sortIcon field="sglCarteiraBanco"></p-sortIcon>
                                <p-columnFilter type="text" field="sglCarteiraBanco" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                         <th pSortableColumn="desCarteiraBanco">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'carteira.descricao' | translate }}
                                <p-sortIcon field="desCarteiraBanco"></p-sortIcon>
                                <p-columnFilter type="text" field="desCarteiraBanco" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th style="width: 8rem"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-carteira>
                    <tr class="p-selectable-row">
                        <td>
                            <span class="p-column-title"></span>
                            {{carteira.banco.codBanco}}
                        </td>
                        <td>
                            <span class="p-column-title"></span>
                            {{carteira.banco.nmeBanco}}
                        </td>
                        <td>
                            <span class="p-column-title"></span>
                            {{carteira.codCarteira}}
                        </td>
                        <td>
                           <span class="p-column-title"></span>
                            {{carteira.sglCarteiraBanco}}
                       </td>
                        <td>
                            <span class="p-column-title"></span>
                            {{carteira.desCarteiraBanco}}
                        </td>
                        <td>
                            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" (click)="editCarteira(carteira)" *ngIf="perfil != null && perfil.nmePerfil === 'ADMTIVIT'"></button>
                            <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteCarteira(carteira)" *ngIf="perfil != null && perfil.nmePerfil === 'ADMTIVIT'"></button>

                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                         {{ 'label.totalde' | translate }}  {{carteiras ? carteiras.length : 0 }} {{ 'carteira.carteiras' | translate }}.
                    </div>
                </ng-template>
            </p-table>

        <p-dialog [(visible)]="carteiraDialog" [style]="{width: '450px'}" header="{{ 'carteira.detalhes' | translate }}" [modal]="true" styleClass="p-fluid">
            <ng-template pTemplate="content">
                <div class="p-field">
                    <h6>{{ 'carteira.banco' | translate }}</h6>
                    <p-autoComplete [(ngModel)]="banco" [suggestions]="filteredBancos"
                                        (completeMethod)="filterBancos($event)" field="nmeBanco" [dropdown]="true" id="banco">
                    </p-autoComplete>
                </div>
                <div class="p-field">
                    <h6>{{ 'carteira.codigo' | translate }}</h6>
                    <input type="text" pInputText id="codCarteira" [(ngModel)]="carteira.codCarteira" required autofocus />
                </div>
                <div class="p-field">
                    <h6>{{ 'carteira.descricao' | translate }}</h6>
                    <input type="text" pInputText id="desCarteiraBanco" [(ngModel)]="carteira.desCarteiraBanco" required autofocus />
                </div>
                <div class="p-field">
                    <h6>{{ 'carteira.sigla' | translate }}</h6>
                    <input type="text" pInputText id="sglCarteiraBanco" [(ngModel)]="carteira.sglCarteiraBanco" required autofocus />
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <button pButton pRipple label="{{ 'label.cancelar' | translate }}" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
                <button pButton pRipple label="{{ 'label.salvar' | translate }}" icon="pi pi-check" class="p-button-text" (click)="saveCarteira()"></button>
            </ng-template>
        </p-dialog>

        <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
    </div>
</div>